import {
  CLEAR_SELECTED_PROJECTS,
  FETCH_PROJECTS_REQUEST,
  FETCH_PROJECTS_SUCCESS,
  FETCH_PROJECTS_FAILURE,
  PROJECT_REQUEST,
  PROJECT_SUCCESS,
  PROJECT_FAILURE,
  TOGGLE_PROJECT
} from '../actions/projectActions'
import uniq from 'lodash/uniq'

const initialState = {
  isFetching: false,
  items: [],
  selectedProjects: []
}

export default function projects(state = initialState, action) {
  switch (action.type) {
    case CLEAR_SELECTED_PROJECTS:
      return { ...state, selectedProjects: [] }
    case PROJECT_REQUEST:
      return Object.assign({}, state, {
        isFetching: true
      })
    case PROJECT_SUCCESS:
      return Object.assign({}, state, {
        isFetching: false,
        items: [...state.items, action.response.result]
      })
    case PROJECT_FAILURE:
      return Object.assign({}, state, {
        isFetching: false
      })
    case FETCH_PROJECTS_REQUEST:
      return { ...state, isFetching: true, items: [] }
    case FETCH_PROJECTS_SUCCESS:
      return { ...state, isFetching: false, items: action.response.result }
    case FETCH_PROJECTS_FAILURE:
      return { ...state, isFetching: false }
    case TOGGLE_PROJECT:
      if (action.selected) {
        return {
          ...state,
          selectedProjects: uniq([...state.selectedProjects, action.projectId])
        }
      }

      const idx = state.selectedProjects.indexOf(action.projectId)

      if (idx === -1) {
        return state
      }

      return {
        ...state,
        selectedProjects: [
          ...state.selectedProjects.slice(0, idx),
          ...state.selectedProjects.slice(idx + 1)
        ]
      }
    default:
      return state
  }
}



// WEBPACK FOOTER //
// ../src/reducers/projects.js